import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router'

import Header from './Header/Header';
import ScanHistory from "./ScanHistory/ScanHistory";
import DatePicker from './DatePicker/DatePicker'

import LoaderGif from '../../images/JioLoader.svg';
import tickIcon from '../../images/tickIcon.svg';

import apiRequest from '../../utils/api.request';
import { extractDateFromDateTime, parseQueryString, appStorage } from '../../utils/utils';
import { passColorEnum } from './Enums/enums';

import config from '../../config.json';
import './History.css';


let covidPassHistory;
const user_id = (parseQueryString().source_user_id || appStorage.getItem('covid_app_user_id'));
const source_id = (parseQueryString().source_id || appStorage.getItem('covid_source_id'));
let red_pass_count;
let green_pass_count;
let orange_pass_count;
let total_pass_count;
let total_pass_list = [];
let red_pass_list = [];
let green_pass_list = [];
let orange_pass_list = [];

export default () => {

    const _formatDateForBackend = (date) => {
        return moment(date).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    }
    const history = useHistory();
    const [passColor, setCurrentPassColor] = useState("all");
    const [apiError, showApiError] = useState(false);
    const [displayList, setDisplayList] = useState([]);
    const [loader, showLoader] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [dateRangeSelected, setDateRangeSelected] = useState(false);
    const [dateRangeString, setDateRangeString] = useState("Today");
    const [hasMore, setHasMore] = useState(true);
    const [noContent, setNoContent] = useState(false);
    const [startAndEndDates, setStartAndEndDates] = useState(() => {
        let startDate = new Date();
        startDate.setHours(0, 0, 0, 0);
        let startDateinZ = _formatDateForBackend(startDate);

        let endDate = new Date()
        endDate.setHours(23, 59, 59, 999);
        let endDateinZ = _formatDateForBackend(endDate);

        return {
            startDate: startDateinZ,
            endDate: endDateinZ
        }
    })
    const [showStartandEndDatePicker, setShowStartandEndDatePicker] = useState(false);

    useEffect(() => {
        if (source_id !== "JioHealthHub") {
            history.push('/')
        }
        return;
    }, [])

    useEffect(() => {
        if (source_id !== "JioHealthHub") {
            return
        }
        if (!user_id) {
            showApiError(true);
            return;
        }
        showLoader(true);
        callCountApi()
            .then((response) => {
                if (!response) {
                    showApiError(true);
                    return;
                }
                red_pass_count = response.history_count[passColorEnum.RED];
                green_pass_count = response.history_count[passColorEnum.GREEN];
                orange_pass_count = response.history_count[passColorEnum.ORANGE];

                total_pass_count = red_pass_count + green_pass_count + orange_pass_count;
                callHistoryApi();
                setHasMore((getCurrentColorCount() > config.cp_history_api_limit));
                showLoader(false);
            })
            .catch(error => {
                showLoader(false);
                showApiError(true);
            });
    }, [startAndEndDates])

    useEffect(() => {
        //adding typeof getCurrentColorCount() so that in initial render this is not called
        if (displayList.length === 0 && typeof getCurrentColorCount() !== "undefined") {
            callHistoryApi();
        }
        // adding limit because the loadfunc is called once more after setting hasmore as false
        if (getCurrentColorCount() <= (displayList.length + config.cp_history_api_limit)) {
            setHasMore(false);
        }
        else if (!hasMore && getCurrentColorCount() && displayList.length !== 0) {
            setHasMore(true);
        }
    }, [displayList])

    useEffect(() => {
        setNoContent(false);
        //checking before rendering new page, if it has more components left to load
        setHasMore((getCurrentColorCount() > (getCurrentColorList().length + config.cp_history_api_limit)));
        const currentColorList = getCurrentColorList();
        setDisplayList(currentColorList);
    }, [passColor])

    const _onDateChangeClicked = () => {
        setShowDatePicker(true)
    }

    const _onPassColorButtonClick = async (passColor) => {
        setCurrentPassColor(passColor);
    }

    const callCountApi = async () => {
        const post_data = {
            user_id: user_id,
            start_date: startAndEndDates.startDate,
            end_date: startAndEndDates.endDate,
        }

        if (!(config.cp_history_base_url && config.count_endpoint)) {
            showApiError(true);
            return;
        }

        const url = config.cp_history_base_url + config.count_endpoint;
        let apiResponse;
        try {
            apiResponse = await apiRequest(url, post_data, true, false, false, false, false, false, false, false, true);
        } catch (err) {
            throw err;
        }
        if (Object.keys(apiResponse.history_count).length !== 3) {
            throw new Error("Invalid Api Response");
        }
        return apiResponse;
    }

    const getCurrentColorCount = () => {
        switch (passColor) {
            case passColorEnum.ALL:
                return total_pass_count;
            case passColorEnum.RED:
                return red_pass_count;
            case passColorEnum.GREEN:
                return green_pass_count;
            case passColorEnum.ORANGE:
                return orange_pass_count;
            default:
                return total_pass_count;
        }
    }

    const getCurrentColorList = () => {
        switch (passColor) {
            case passColorEnum.ALL:
                return total_pass_list;
            case passColorEnum.RED:
                return red_pass_list;
            case passColorEnum.GREEN:
                return green_pass_list;
            case passColorEnum.ORANGE:
                return orange_pass_list
            default:
                return total_pass_list
        }
    }

    const setCurrentColorList = (updatedList) => {
        switch (passColor) {
            case passColorEnum.ALL:
                total_pass_list = updatedList;
                break;
            case passColorEnum.RED:
                red_pass_list = updatedList;
                break;
            case passColorEnum.GREEN:
                green_pass_list = updatedList;
                break;
            case passColorEnum.ORANGE:
                orange_pass_list = updatedList;
                break;
            default:
                total_pass_list = updatedList;
        }
    }

    const _resetColorList = () => {
        total_pass_list = []
        red_pass_list = []
        green_pass_list = []
        orange_pass_list = []
    }

    const callHistoryApi = async () => {
        if (!user_id) {
            showApiError(true);
            return;
        }

        if (typeof getCurrentColorCount() === "undefined") {
            return;
        }

        if (getCurrentColorCount() === 0) {
            setHasMore(false);
            setNoContent(true);
            return;
        }
        else {
            setNoContent(false);
        }

        const post_data = {
            "user_id": user_id,
            "start_date": startAndEndDates.startDate,
            "end_date": startAndEndDates.endDate,
            "limit": config.cp_history_api_limit,
            "start": displayList.length,
        }

        if (passColor !== "all") {
            post_data.pass_value = passColor;
        }
        if (!(config.cp_history_base_url && config.histroy_endpoint)) {
            showApiError(true);
            return;
        }
        const url = config.cp_history_base_url + config.histroy_endpoint;
        let apiResponse;
        try {
            apiResponse = await apiRequest(url, post_data, true, false, false, false, false, false, false, false, true);
        } catch (err) {
            showApiError(true);
            return;
        }
        if (!apiResponse.history.length) {
            setHasMore(false);
            return;
        }

        covidPassHistory = apiResponse.history;
        let displayListClone = displayList.slice();
        displayListClone = displayListClone.concat(covidPassHistory);
        setDisplayList(displayListClone);
        setCurrentColorList(displayListClone);
    }

    const _setStartAndEndDate = () => {
        if (!dateRangeSelected) {
            _setShowDatePickerAndCallApi(new Date(), new Date())
        }
        else {
            setShowStartandEndDatePicker(true)
        }
        setShowDatePicker(false);
    }

    const _setShowDatePickerAndCallApi = (startDate, endDate) => {
        if (!dateRangeSelected) {
            setDateRangeString("Today");
        }
        else {
            const dateRangeStringified = `${extractDateFromDateTime(startDate)} - ${extractDateFromDateTime(endDate)}`;
            setDateRangeString(dateRangeStringified);
        }
        if (showStartandEndDatePicker) {
            setShowStartandEndDatePicker(false)
        }
        _resetColorList();
        startDate.setHours(0, 0, 0, 0)
        let startDateinZ = _formatDateForBackend(startDate);
        endDate.setHours(23, 59, 59, 999)
        let endDateinZ = _formatDateForBackend(endDate);
        setStartAndEndDates(() => {
            return {
                startDate: startDateinZ,
                endDate: endDateinZ
            }
        })
    }

    if (loader) {
        return (
            <div className="loader-wrapper">
                <div><img className="loader" src={LoaderGif} alt="loader" /></div>
            </div>
        )
    }
    else if (apiError) {
        return (
            <div className="loader-wrapper">
                <div>Something Went Wrong! Please try again</div>
            </div>
        )
    }
    else if (showStartandEndDatePicker) {
        return (
            <DatePicker
                startDate={startAndEndDates.startDate}
                endDate={startAndEndDates.endDate}
                onDateSelected={_setShowDatePickerAndCallApi}
            />
        )
    }
    return (
        <div className="history-container">
            <Header
                dateRangeString={dateRangeString}
                _onDateChangeClicked={_onDateChangeClicked}
                _onPassColorButtonClick={_onPassColorButtonClick}
                total_count={total_pass_count}
                red_pass_count={red_pass_count}
                green_pass_count={green_pass_count}
                orange_pass_count={orange_pass_count}
                selected={passColor}
            ></Header>
            <ScanHistory
                loadFunc={callHistoryApi}
                scanHistory={displayList}
                noContent={noContent}
                hasMore={hasMore}
            />
            {
                showDatePicker ?
                    <div className="date-picker-main-container">
                        <div className="date-picker-grey-background" onClick={() => { setShowDatePicker(false) }}></div>
                        <div className="date-picker-radio-button-container">
                            <div className="date-picker-radio-button-container-header">Select Date Range</div>
                            <div className="date-picker-radio-button" onClick={() => { if (dateRangeSelected) setDateRangeSelected(false) }}>
                                <div className="radio-button-container">
                                    {
                                        !dateRangeSelected ?
                                            <img src={tickIcon} alt="Tick Icon" />
                                            :
                                            <></>
                                    }
                                </div>
                                <div className="date-picker-today">Today</div>
                            </div>
                            <div className="date-picker-radio-button" onClick={() => { if (!dateRangeSelected) setDateRangeSelected(true) }}>
                                <div className="radio-button-container">
                                    {
                                        dateRangeSelected ?
                                            <img src={tickIcon} alt="Tick Icon" />
                                            :
                                            <></>
                                    }
                                </div>
                                <div className="date-picker-today">Custom Dates</div>
                            </div>
                            <div className="date-picker-select-container">
                                <div className="date-picker-select" onClick={() => { _setStartAndEndDate() }}>Select</div>
                            </div>
                        </div>
                    </div>
                    :
                    <></>
            }
        </div>
    )
}